import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.consultations');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

type ConsultationFilter = 'all' | 'sale' | 'buy' | 'qna' | 'case' | 'valuation' | 'ai';

interface DocumentAttachment {
    kind: 'quote' | 'attachment';
    label: string;
    fileName: string;
    url: string;
}

interface DocumentBundle {
    title: string;
    message: string;
    attachments: DocumentAttachment[];
}

interface ConsultationAnswer {
    id: string;
    adminAnswer: string;
    answeredAt: string;
    documentBundle?: DocumentBundle | null;
}

interface AiCandidateField {
    label: string;
    value: string;
}

interface AiCandidateDetail {
    title: string;
    candidateId: string;
    matchRate: string;
    facts: AiCandidateField[];
    analysis: string;
    summary: string;
    searchConditions: AiCandidateField[];
    request: string;
}

interface ConsultationItem {
    id: string;
    coreId: string;
    receiptNo: string;
    flow: string;
    flowLabel: string;
    category: string;
    sourceRoute: string;
    subject: string;
    requestBody: string;
    requestLines: string[];
    aiCandidate?: AiCandidateDetail | null;
    status: string;
    statusLabel: string;
    adminAnswer: string;
    adminAnswers: ConsultationAnswer[];
    adminDocumentBundle?: DocumentBundle | null;
    createdAt: string;
    updatedAt: string;
    answeredAt: string;
    completedAt?: string;
}

interface FilterOption {
    key: ConsultationFilter;
    label: string;
}

@Component({
    selector: 'wiz-page-consultations',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.consultations/view.scss */
:host {
  display: block;
}

* {
  box-sizing: border-box;
}

.market-consultations-page {
  min-height: calc(100vh - 70px);
  padding: 30px 0 72px;
  color: #183126;
}

.market-consultations-container {
  width: min(100% - 40px, 1248px);
  margin: 0 auto;
}

.market-consultations-breadcrumb {
  display: flex;
  align-items: center;
  gap: 9px;
  margin-bottom: 18px;
  color: #829087;
  font-size: 10px;
}
.market-consultations-breadcrumb a {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #587065;
  text-decoration: none;
}
.market-consultations-breadcrumb svg {
  width: 14px;
  height: 14px;
}
.market-consultations-breadcrumb strong {
  color: #2b4b3b;
}

.member-kicker {
  color: #63a67d;
  font-size: 9px;
  font-weight: 900;
  letter-spacing: 0.16em;
}

.market-consultations-hero {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  min-height: 204px;
  padding: 38px 42px;
  overflow: hidden;
  border-radius: 24px;
  background: radial-gradient(circle at 92% 0, rgba(130, 194, 110, 0.25), transparent 25rem), linear-gradient(145deg, #133d2d, #09261d);
  box-shadow: 0 24px 55px rgba(18, 66, 42, 0.14);
  color: #fff;
}
.market-consultations-hero::after {
  position: absolute;
  top: -85px;
  right: 26%;
  width: 230px;
  height: 230px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 50%;
  content: "";
}
.market-consultations-hero h1 {
  margin: 10px 0 0;
  font-size: 30px;
  font-weight: 850;
  letter-spacing: -0.045em;
}
.market-consultations-hero p {
  max-width: 560px;
  margin: 12px 0 0;
  color: #b9cec2;
  font-size: 13px;
  line-height: 1.7;
}

.market-consultations-hero-copy,
.market-consultations-summary {
  position: relative;
  z-index: 1;
}

.market-consultations-summary {
  display: grid;
  grid-template-columns: repeat(3, 112px);
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.13);
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.07);
  backdrop-filter: blur(12px);
}
.market-consultations-summary div {
  padding: 18px 16px;
}
.market-consultations-summary div + div {
  border-left: 1px solid rgba(255, 255, 255, 0.1);
}
.market-consultations-summary dt {
  color: #a6c3b2;
  font-size: 9px;
  font-weight: 750;
}
.market-consultations-summary dd {
  margin: 7px 0 2px;
  color: #fff;
  font-size: 24px;
  font-weight: 850;
}
.market-consultations-summary small {
  color: #7fa491;
  font-size: 8px;
}

.market-consultations-panel {
  margin-top: 20px;
  overflow: hidden;
  border: 1px solid #dce6e0;
  border-radius: 22px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 18px 42px rgba(24, 70, 46, 0.07);
}

.market-consultations-toolbar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 22px;
  padding: 26px 28px 22px;
}
.market-consultations-toolbar h2 {
  margin: 6px 0 0;
  color: #173125;
  font-size: 19px;
  font-weight: 850;
  letter-spacing: -0.025em;
}
.market-consultations-toolbar p {
  margin: 7px 0 0;
  color: #74867d;
  font-size: 11px;
  line-height: 1.6;
}
.market-consultations-toolbar > button {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  height: 38px;
  padding: 0 13px;
  border: 1px solid #d4e0da;
  border-radius: 10px;
  background: #fff;
  color: #3d5b4d;
  font-size: 10px;
  font-weight: 800;
  cursor: pointer;
}
.market-consultations-toolbar > button:hover:not(:disabled) {
  border-color: #93bca3;
  background: #f4faf6;
}
.market-consultations-toolbar > button:disabled {
  cursor: wait;
  opacity: 0.58;
}
.market-consultations-toolbar > button svg {
  width: 15px;
  height: 15px;
}
.market-consultations-toolbar > button svg.is-spinning {
  animation: consultation-spin 0.8s linear infinite;
}

.market-consultations-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  padding: 0 28px 22px;
  border-bottom: 1px solid #e7eeea;
}
.market-consultations-filters button {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  height: 34px;
  padding: 0 11px;
  border: 1px solid #dce5e0;
  border-radius: 999px;
  background: #f9fbfa;
  color: #60736a;
  font-size: 10px;
  font-weight: 800;
  cursor: pointer;
}
.market-consultations-filters button em {
  min-width: 19px;
  padding: 2px 5px;
  border-radius: 999px;
  background: #ebf0ed;
  color: #76877f;
  font-size: 8px;
  font-style: normal;
  text-align: center;
}
.market-consultations-filters button:hover, .market-consultations-filters button.is-active {
  border-color: #3b8c60;
  background: #eaf5ed;
  color: #1f7048;
}
.market-consultations-filters button.is-active em {
  background: #2a7b50;
  color: #fff;
}

.market-consultations-partial-warning {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 11px 32px;
  border-top: 1px solid #f0dfb8;
  border-bottom: 1px solid #f0dfb8;
  color: #795c21;
  background: #fff9ea;
  font-size: 10px;
  line-height: 1.6;
}
.market-consultations-partial-warning a {
  flex: 0 0 auto;
  color: #765513;
  font-weight: 850;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.market-consultations-state {
  display: grid;
  min-height: 390px;
  place-items: center;
  align-content: center;
  padding: 45px 24px;
  text-align: center;
}
.market-consultations-state > strong {
  margin-top: 16px;
  color: #274438;
  font-size: 15px;
}
.market-consultations-state > p {
  max-width: 460px;
  margin: 8px 0 0;
  color: #7b8c84;
  font-size: 11px;
  line-height: 1.7;
}
.market-consultations-state > button,
.market-consultations-state > a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 38px;
  margin-top: 18px;
  padding: 0 15px;
  border: 0;
  border-radius: 10px;
  background: #1b7049;
  color: #fff;
  font-size: 10px;
  font-weight: 800;
  text-decoration: none;
  cursor: pointer;
}

.market-consultations-state-mark {
  display: grid;
  width: 58px;
  height: 58px;
  place-items: center;
  border-radius: 18px;
  background: #eaf4ed;
  color: #27754f;
}
.market-consultations-state-mark svg {
  width: 25px;
  height: 25px;
}
.market-consultations-state-mark.is-error {
  background: #fff0e3;
  color: #af651b;
}
.market-consultations-state-mark.is-loading {
  grid-template-columns: repeat(3, 7px);
  gap: 5px;
}
.market-consultations-state-mark.is-loading span {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #26764f;
  animation: consultation-pulse 1s ease-in-out infinite;
}
.market-consultations-state-mark.is-loading span:nth-child(2) {
  animation-delay: 0.15s;
}
.market-consultations-state-mark.is-loading span:nth-child(3) {
  animation-delay: 0.3s;
}

.market-consultations-workspace {
  display: grid;
  grid-template-columns: 380px minmax(0, 1fr);
  min-height: 590px;
}

.market-consultations-list {
  max-height: 720px;
  padding: 12px;
  overflow-y: auto;
  border-right: 1px solid #e2ebe6;
  background: #f7faf8;
}

.market-consultation-card {
  display: block;
  width: 100%;
  padding: 17px;
  border: 1px solid transparent;
  border-radius: 14px;
  background: transparent;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.16s, background 0.16s, box-shadow 0.16s, transform 0.16s;
}
.market-consultation-card + .market-consultation-card {
  margin-top: 6px;
}
.market-consultation-card:hover {
  background: #fff;
  transform: translateY(-1px);
}
.market-consultation-card.is-selected {
  border-color: #a8ceb6;
  background: #fff;
  box-shadow: 0 9px 22px rgba(27, 92, 56, 0.08);
}
.market-consultation-card > strong {
  display: -webkit-box;
  margin-top: 11px;
  overflow: hidden;
  color: #203a2e;
  font-size: 12px;
  line-height: 1.55;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.market-consultation-card > p {
  margin: 8px 0 0;
  overflow: hidden;
  color: #7b8b83;
  font-size: 9px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.market-consultation-card > time {
  display: block;
  margin-top: 6px;
  color: #9aa7a0;
  font-size: 8px;
}

.market-consultation-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.market-consultation-flow,
.market-consultation-status {
  display: inline-flex;
  align-items: center;
  min-height: 23px;
  padding: 0 8px;
  border-radius: 999px;
  font-size: 8px;
  font-weight: 850;
  white-space: nowrap;
}

.market-consultation-flow {
  background: #edf4ef;
  color: #3b7253;
}
.market-consultation-flow.is-buy {
  background: #e8f5f5;
  color: #24777a;
}
.market-consultation-flow.is-sale {
  background: #e3f3ea;
  color: #176b45;
}
.market-consultation-flow.is-qna {
  background: #f0edfb;
  color: #6950a3;
}
.market-consultation-flow.is-case {
  background: #eaf1fb;
  color: #3c6593;
}
.market-consultation-flow.is-valuation {
  background: #fff1dd;
  color: #9a641f;
}
.market-consultation-flow.is-ai {
  background: #e8eefc;
  color: #4c62a4;
}

.market-consultation-status.is-received {
  background: #edf3ef;
  color: #587064;
}
.market-consultation-status.is-reviewing {
  background: #fff4d9;
  color: #946514;
}
.market-consultation-status.is-answered {
  background: #e2f5e9;
  color: #177148;
}
.market-consultation-status.is-closed {
  background: #edf0f2;
  color: #66727a;
}
.market-consultation-status.is-cancelled {
  background: #fbe9e9;
  color: #9d4848;
}

.market-consultation-detail {
  padding: 32px 34px;
  background: #fff;
}
.market-consultation-detail > header {
  padding-bottom: 25px;
  border-bottom: 1px solid #e5ece8;
}
.market-consultation-detail > header > div:first-child {
  display: flex;
  align-items: center;
  gap: 8px;
}
.market-consultation-detail > header h2 {
  margin: 16px 0 0;
  color: #172f23;
  font-size: 21px;
  font-weight: 850;
  letter-spacing: -0.025em;
  line-height: 1.45;
}
.market-consultation-detail > header dl {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 22px;
  margin: 18px 0 0;
}
.market-consultation-detail > header dl div {
  display: flex;
  align-items: center;
  gap: 7px;
}
.market-consultation-detail > header dl dt {
  color: #8a9891;
  font-size: 9px;
}
.market-consultation-detail > header dl dd {
  margin: 0;
  color: #4d6358;
  font-size: 9px;
  font-weight: 800;
}

.market-consultation-thread {
  min-height: 430px;
  padding: 4px 0 0;
}

.market-consultation-date-divider {
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 22px 0;
  color: #84938c;
  font-size: 9px;
  font-weight: 750;
  white-space: nowrap;
}
.market-consultation-date-divider::before, .market-consultation-date-divider::after {
  height: 1px;
  flex: 1 1 auto;
  background: #e2eae6;
  content: "";
}

.market-consultation-message {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.market-consultation-message + .market-consultation-message {
  margin-top: 15px;
}
.market-consultation-message.is-request {
  justify-content: flex-end;
}
.market-consultation-message.is-request .market-consultation-message-content {
  align-items: flex-end;
}
.market-consultation-message.is-request .market-consultation-message-bubble {
  border-bottom-right-radius: 5px;
  background: #eef7f1;
  color: #27493a;
}
.market-consultation-message.is-request .market-consultation-participant {
  background: #dcefe2;
  color: #1b6240;
}
.market-consultation-message.is-admin .market-consultation-message-bubble {
  border: 1px solid #e0e8e3;
  border-bottom-left-radius: 5px;
  background: #fff;
  color: #30483d;
}
.market-consultation-message.is-admin .market-consultation-participant {
  background: #d5ebdc;
  color: #165d3c;
}

.market-consultation-message-content {
  display: flex;
  width: min(72%, 590px);
  flex-direction: column;
}
.market-consultation-message-content > time {
  margin-top: 6px;
  color: #8b9992;
  font-size: 8px;
}

.market-consultation-message-bubble {
  width: fit-content;
  max-width: 100%;
  padding: 15px 17px;
  border-radius: 15px;
}
.market-consultation-message-bubble > p {
  margin: 0;
  font-size: 12px;
  line-height: 1.75;
  white-space: pre-line;
}

.market-consultation-participant {
  display: grid;
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  place-items: center;
  border-radius: 50%;
  font-size: 9px;
  font-weight: 850;
}

.market-consultation-request-lines {
  display: grid;
  gap: 5px;
}
.market-consultation-request-lines p {
  margin: 0;
  font-size: 11px;
  line-height: 1.65;
  white-space: pre-line;
}

.market-consultation-message.has-document-card .market-consultation-message-content {
  width: min(82%, 660px);
}
.market-consultation-message.has-document-card .market-consultation-message-bubble.is-document-card {
  width: 100%;
  padding: 0;
  overflow: hidden;
  border-color: #cfe1d7;
  border-radius: 18px;
  border-bottom-left-radius: 6px;
  box-shadow: 0 12px 30px rgba(25, 77, 50, 0.08);
}

.admin-document-card {
  width: 100%;
}
.admin-document-card > footer {
  padding: 11px 18px;
  border-top: 1px solid #e7efeb;
  background: #fafcfb;
  color: #819088;
  font-size: 8px;
  line-height: 1.5;
}

.admin-document-card__header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 18px;
  border-bottom: 1px solid #dce9e2;
  background: linear-gradient(135deg, #eef8f2 0%, #e5f2ea 100%);
}
.admin-document-card__header > div {
  display: grid;
  min-width: 0;
  flex: 1 1 auto;
  gap: 3px;
}
.admin-document-card__header > div > span {
  color: #5a846c;
  font-size: 8px;
  font-weight: 850;
  letter-spacing: 0.06em;
}
.admin-document-card__header > div > strong {
  color: #1c4933;
  font-size: 14px;
  font-weight: 850;
  line-height: 1.4;
}
.admin-document-card__header > em {
  flex: 0 0 auto;
  padding: 5px 8px;
  border: 1px solid #c7ddcf;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.75);
  color: #47705a;
  font-size: 8px;
  font-style: normal;
  font-weight: 800;
  white-space: nowrap;
}

.admin-document-card__icon {
  display: grid;
  width: 38px;
  height: 38px;
  flex: 0 0 38px;
  place-items: center;
  border-radius: 12px;
  background: #24744c;
  color: #fff;
}
.admin-document-card__icon svg {
  width: 19px;
  height: 19px;
}

.admin-document-card__files {
  display: grid;
  gap: 9px;
  padding: 14px;
}
.admin-document-card__files a {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 11px;
  padding: 12px;
  border: 1px solid #e0e9e4;
  border-radius: 12px;
  background: #fff;
  color: inherit;
  text-decoration: none;
  transition: border-color 0.16s ease, background 0.16s ease, transform 0.16s ease;
}
.admin-document-card__files a:hover {
  border-color: #85b79a;
  background: #f7fbf8;
  transform: translateY(-1px);
}
.admin-document-card__files a.is-quote {
  border-color: #f0c9c9;
  background: #fffafa;
}
.admin-document-card__files a.is-quote:hover {
  border-color: #d58c8c;
  background: #fff5f5;
}
.admin-document-card__files a.is-quote .admin-document-card__file-icon {
  background: #fdecec;
  color: #b84141;
}

.admin-document-card__message {
  margin: 0;
  padding: 16px 18px 0;
  color: #30483d;
  font-size: 11px;
  line-height: 1.75;
  white-space: pre-wrap;
}

.admin-document-card__file-icon {
  display: grid;
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  place-items: center;
  border-radius: 10px;
  background: #eef6f1;
  color: #2f7652;
}
.admin-document-card__file-icon svg {
  width: 17px;
  height: 17px;
}

.admin-document-card__file-copy {
  display: grid;
  min-width: 0;
  flex: 1 1 auto;
  gap: 3px;
}
.admin-document-card__file-copy strong {
  color: #2b493a;
  font-size: 11px;
  font-weight: 850;
}
.admin-document-card__file-copy small {
  overflow: hidden;
  color: #809087;
  font-size: 8px;
  line-height: 1.45;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.admin-document-card__format {
  display: inline-flex;
  height: 22px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  padding: 0 7px;
  border: 1px solid #e7b7b7;
  border-radius: 999px;
  background: #fff0f0;
  color: #a93232;
  font-size: 8px;
  font-weight: 900;
  letter-spacing: 0.04em;
  white-space: nowrap;
}

.admin-document-card__open {
  display: inline-flex;
  height: 30px;
  flex: 0 0 auto;
  align-items: center;
  gap: 5px;
  padding: 0 9px;
  border-radius: 8px;
  background: #246f4a;
  color: #fff;
  font-size: 8px;
  font-weight: 850;
  white-space: nowrap;
}
.admin-document-card__open svg {
  width: 12px;
  height: 12px;
}

.market-consultation-message.has-ai-card .market-consultation-message-content {
  width: min(88%, 720px);
}
.market-consultation-message.has-ai-card .market-consultation-message-bubble.is-ai-card {
  width: 100%;
  padding: 0;
  overflow: hidden;
  border: 1px solid #d8e8df;
  border-radius: 18px;
  border-bottom-right-radius: 6px;
  background: #fff;
  box-shadow: 0 12px 30px rgba(25, 77, 50, 0.08);
  color: #213f31;
}

.ai-candidate-card {
  width: 100%;
}

.ai-candidate-card__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding: 20px 22px;
  border-bottom: 1px solid #dfece5;
  background: linear-gradient(135deg, #f2faf5 0%, #eaf5ee 100%);
}

.ai-candidate-card__identity {
  display: flex;
  min-width: 0;
  align-items: flex-start;
  gap: 12px;
}
.ai-candidate-card__identity > div {
  display: grid;
  min-width: 0;
  gap: 4px;
}
.ai-candidate-card__identity > div > span {
  color: #4d8265;
  font-size: 9px;
  font-weight: 850;
  letter-spacing: 0.08em;
}
.ai-candidate-card__identity strong {
  color: #163929;
  font-size: 15px;
  font-weight: 850;
  line-height: 1.45;
  overflow-wrap: anywhere;
}
.ai-candidate-card__identity small {
  color: #779087;
  font-size: 9px;
  line-height: 1.4;
  overflow-wrap: anywhere;
}

.ai-candidate-card__mark {
  display: grid;
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  place-items: center;
  border-radius: 11px;
  background: #256f4a;
  box-shadow: 0 7px 16px rgba(28, 105, 66, 0.18);
  color: #fff;
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 0.04em;
}

.ai-candidate-card__score {
  display: grid;
  min-width: 70px;
  flex: 0 0 auto;
  gap: 2px;
  padding: 9px 12px;
  border: 1px solid #cde2d5;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.82);
  text-align: center;
}
.ai-candidate-card__score span {
  color: #6c8879;
  font-size: 8px;
  font-weight: 750;
}
.ai-candidate-card__score strong {
  color: #1b7249;
  font-size: 17px;
  font-weight: 900;
}

.ai-candidate-card__facts {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  margin: 0;
  border-bottom: 1px solid #e4ece8;
  background: #fff;
}
.ai-candidate-card__facts div {
  min-width: 0;
  padding: 14px 16px;
}
.ai-candidate-card__facts div + div {
  border-left: 1px solid #edf2ef;
}
.ai-candidate-card__facts dt {
  margin-bottom: 5px;
  color: #84958d;
  font-size: 8px;
  font-weight: 750;
}
.ai-candidate-card__facts dd {
  margin: 0;
  color: #2d493b;
  font-size: 10px;
  font-weight: 800;
  line-height: 1.45;
  overflow-wrap: anywhere;
}

.ai-candidate-card__section {
  margin: 16px 20px 0;
  padding: 14px 15px;
  border: 1px solid #e2ebe6;
  border-radius: 12px;
  background: #fafcfb;
}
.ai-candidate-card__section.is-analysis {
  border-color: #d8e4f5;
  background: #f3f7fd;
}
.ai-candidate-card__section.is-analysis > span {
  color: #526ea4;
}
.ai-candidate-card__section > span {
  display: block;
  margin-bottom: 6px;
  color: #52705f;
  font-size: 9px;
  font-weight: 850;
}
.ai-candidate-card__section p {
  margin: 0;
  color: #334f41;
  font-size: 10px;
  line-height: 1.7;
  white-space: pre-line;
}

.ai-candidate-card__search {
  margin: 18px 20px 0;
  padding-top: 16px;
  border-top: 1px solid #e4ece8;
}
.ai-candidate-card__search h3 {
  margin: 0 0 10px;
  color: #557064;
  font-size: 9px;
  font-weight: 850;
}
.ai-candidate-card__search dl {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin: 0;
}
.ai-candidate-card__search dl > div {
  min-width: 0;
  padding: 10px 12px;
  border-radius: 10px;
  background: #f4f8f6;
}
.ai-candidate-card__search dl > div.is-wide {
  grid-column: 1/-1;
}
.ai-candidate-card__search dt {
  margin-bottom: 4px;
  color: #829188;
  font-size: 8px;
  font-weight: 750;
}
.ai-candidate-card__search dd {
  margin: 0;
  color: #304d3f;
  font-size: 10px;
  font-weight: 750;
  line-height: 1.55;
  overflow-wrap: anywhere;
}

.ai-candidate-card__request {
  margin: 18px 20px 20px;
  padding: 13px 15px;
  border-left: 3px solid #2f8057;
  border-radius: 4px 10px 10px 4px;
  background: #eef7f1;
}
.ai-candidate-card__request span {
  display: block;
  margin-bottom: 5px;
  color: #337454;
  font-size: 9px;
  font-weight: 850;
}
.ai-candidate-card__request p {
  margin: 0;
  color: #284838;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.65;
  white-space: pre-line;
}

.market-consultation-answer-pending {
  margin: 28px auto 0;
  padding: 15px;
  border: 1px dashed #ccd9d2;
  border-radius: 11px;
  background: rgba(255, 255, 255, 0.7);
}
.market-consultation-answer-pending strong {
  color: #526b5e;
  font-size: 10px;
}
.market-consultation-answer-pending p {
  margin: 6px 0 0;
  color: #87958e;
  font-size: 9px;
  line-height: 1.6;
}
.market-consultation-answer-pending.is-sale-status {
  border-style: solid;
  border-color: #c6dfd0;
  background: #f1f8f4;
}
.market-consultation-answer-pending.is-sale-status strong {
  color: #246244;
}

.market-consultation-empty-copy {
  margin: 0;
  color: #89978f;
  font-size: 11px;
}

.market-consultation-detail-actions {
  display: flex;
  gap: 8px;
  margin-top: 24px;
}
.market-consultation-detail-actions a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 38px;
  padding: 0 14px;
  border: 1px solid #d3dfd8;
  border-radius: 10px;
  color: #3e5b4d;
  background: #fff;
  font-size: 10px;
  font-weight: 800;
  text-decoration: none;
}
.market-consultation-detail-actions a:first-child {
  border-color: #1f754c;
  background: #1f754c;
  color: #fff;
}

@keyframes consultation-spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes consultation-pulse {
  0%, 100% {
    opacity: 0.3;
    transform: translateY(1px);
  }
  50% {
    opacity: 1;
    transform: translateY(-2px);
  }
}
@media (min-width: 1280px) {
  .market-consultations-panel {
    width: calc(100% + clamp(120px, 12vw, 240px));
    margin-left: 0;
    transform: none;
  }
}
@media (max-width: 1040px) {
  .market-consultations-hero {
    grid-template-columns: 1fr;
    gap: 28px;
  }
  .market-consultations-summary {
    width: fit-content;
  }
  .market-consultations-workspace {
    grid-template-columns: 330px minmax(0, 1fr);
  }
}
@media (max-width: 780px) {
  .market-consultations-page {
    padding: 20px 0 48px;
  }
  .market-consultations-container {
    width: min(100% - 24px, 1248px);
  }
  .market-consultations-hero {
    padding: 28px 22px;
    border-radius: 19px;
  }
  .market-consultations-hero h1 {
    font-size: 25px;
  }
  .market-consultations-summary {
    grid-template-columns: repeat(3, minmax(82px, 1fr));
    width: 100%;
  }
  .market-consultations-summary div {
    padding: 14px 11px;
  }
  .market-consultations-summary dd {
    font-size: 20px;
  }
  .market-consultations-toolbar {
    display: block;
    padding: 22px 18px 18px;
  }
  .market-consultations-toolbar > button {
    margin-top: 16px;
  }
  .market-consultations-filters {
    padding: 0 18px 18px;
  }
  .market-consultations-workspace {
    display: block;
  }
  .market-consultations-list {
    max-height: 360px;
    border-right: 0;
    border-bottom: 1px solid #e2ebe6;
  }
  .market-consultation-detail {
    padding: 24px 18px;
  }
  .market-consultation-message-content {
    width: min(82%, 590px);
  }
  .market-consultation-message.has-document-card,
  .market-consultation-message.has-ai-card {
    gap: 8px;
  }
  .market-consultation-message.has-document-card .market-consultation-message-content,
  .market-consultation-message.has-ai-card .market-consultation-message-content {
    width: calc(100% - 44px);
  }
  .admin-document-card__header {
    align-items: flex-start;
    padding: 15px;
  }
  .admin-document-card__files {
    padding: 11px;
  }
  .admin-document-card__files a {
    align-items: flex-start;
  }
  .admin-document-card__open {
    width: 30px;
    padding: 0;
    justify-content: center;
    font-size: 0;
  }
  .ai-candidate-card__header {
    padding: 16px;
  }
  .ai-candidate-card__facts {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .ai-candidate-card__facts div:nth-child(3) {
    border-left: 0;
  }
  .ai-candidate-card__facts div:nth-child(n+3) {
    border-top: 1px solid #edf2ef;
  }
  .ai-candidate-card__section,
  .ai-candidate-card__search {
    margin-right: 14px;
    margin-left: 14px;
  }
  .ai-candidate-card__search dl {
    grid-template-columns: 1fr;
  }
  .ai-candidate-card__search dl > div.is-wide {
    grid-column: auto;
  }
  .ai-candidate-card__request {
    margin: 16px 14px;
  }
  .market-consultation-message-bubble {
    padding: 13px 14px;
  }
  .market-consultation-participant {
    width: 36px;
    height: 36px;
    flex-basis: 36px;
    font-size: 8px;
  }
  .market-consultation-detail-actions {
    flex-direction: column;
  }
  .market-consultation-detail-actions a {
    width: 100%;
  }
}`],
})
export class PageConsultationsComponent implements OnInit {
    public items: ConsultationItem[] = [];
    public selectedItem: ConsultationItem | null = null;
    public selectedFilter: ConsultationFilter = 'all';
    public loading: boolean = true;
    public loadError: string = '';
    public saleLoadError: string = '';
    public filterOptions: FilterOption[] = [
        { key: 'all', label: '전체' },
        { key: 'sale', label: '판매등록' },
        { key: 'buy', label: '구매상담' },
        { key: 'qna', label: '자유·요건 상담' },
        { key: 'case', label: '사건상담' },
        { key: 'valuation', label: '기술가치평가' },
        { key: 'ai', label: 'AI 후보상담' }
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (!this.service.auth.allow('/access')) return;
        await this.loadConsultations();
    }

    public get filteredItems() {
        if (this.selectedFilter === 'all') return this.items;
        return this.items.filter((item) => this.matchesFilter(item, this.selectedFilter));
    }

    public get completedCount() {
        const completedStatuses = ['ANSWERED', 'COMPLETED', 'CLOSED', 'APPROVED', 'PUBLISHED', 'REJECTED', 'CANCELLED', 'DELETED'];
        return this.items.filter((item) => !!item.adminAnswer || completedStatuses.includes(item.status)).length;
    }

    public get pendingCount() {
        return this.items.length - this.completedCount;
    }

    public async loadConsultations() {
        this.loading = true;
        this.loadError = '';
        await this.service.render();

        try {
            const { code, data } = await wiz.call('list_consultations');
            if (code === 200) {
                const items: ConsultationItem[] = Array.isArray(data?.items) ? data.items : [];
                this.items = items
                    .map((item) => ({
                        ...item,
                        aiCandidate: this.buildAiCandidate(item),
                        adminAnswers: (Array.isArray(item.adminAnswers) ? item.adminAnswers : []).map((answer) => ({
                            ...answer,
                            documentBundle: this.buildDocumentBundle(answer.adminAnswer)
                        })),
                        adminDocumentBundle: this.buildDocumentBundle(item.adminAnswer)
                    }))
                    .sort((left, right) => this.consultationTimestamp(right.createdAt) - this.consultationTimestamp(left.createdAt));
                this.saleLoadError = data?.saleError || '';
                this.syncSelectedItem();
            } else {
                this.loadError = data?.message || '내 상담이력을 불러오지 못했습니다.';
                this.saleLoadError = '';
            }
        } catch (error) {
            this.loadError = '상담이력을 불러오는 중 연결이 원활하지 않습니다.';
            this.saleLoadError = '';
        }

        this.loading = false;
        await this.service.render();
    }

    public async selectFilter(filter: ConsultationFilter) {
        this.selectedFilter = filter;
        this.syncSelectedItem();
        await this.service.render();
    }

    public async selectItem(item: ConsultationItem) {
        this.selectedItem = item;
        await this.service.render();
    }

    public filterCount(filter: ConsultationFilter) {
        if (filter === 'all') return this.items.length;
        return this.items.filter((item) => this.matchesFilter(item, filter)).length;
    }

    public isSelected(item: ConsultationItem) {
        return this.selectedItem?.id === item.id;
    }

    public statusClass(item: ConsultationItem) {
        if (item.flow === 'sale_registration') {
            if (['APPROVED', 'PUBLISHED'].includes(item.status)) return 'is-answered';
            if (['UNDER_REVIEW', 'REVIEWING'].includes(item.status)) return 'is-reviewing';
            if (['REJECTED', 'CANCELLED'].includes(item.status)) return 'is-cancelled';
            if (['DELETED', 'CLOSED'].includes(item.status)) return 'is-closed';
            return 'is-received';
        }
        if (item.adminAnswer || ['ANSWERED', 'COMPLETED'].includes(item.status)) return 'is-answered';
        if (item.status === 'REVIEWING') return 'is-reviewing';
        if (item.status === 'CANCELLED') return 'is-cancelled';
        if (item.status === 'CLOSED') return 'is-closed';
        return 'is-received';
    }

    public flowClass(item: ConsultationItem) {
        if (item.flow === 'sale_registration') return 'is-sale';
        if (item.flow === 'valuation_request') return 'is-valuation';
        if (item.flow === 'ai_candidate_consultation') return 'is-ai';
        if (item.flow === 'case_consultation') return 'is-case';
        if (item.flow === 'buy_inquiry') return 'is-buy';
        return 'is-qna';
    }

    public trackById(_index: number, item: ConsultationItem) {
        return item.id;
    }

    public consultationDateTime(value: string) {
        const date = this.consultationDate(value);
        if (!date) return value || '';
        const koreanTime = new Date(date.getTime() + (9 * 60 * 60 * 1000));
        const year = koreanTime.getUTCFullYear();
        const month = String(koreanTime.getUTCMonth() + 1).padStart(2, '0');
        const day = String(koreanTime.getUTCDate()).padStart(2, '0');
        const hour = String(koreanTime.getUTCHours()).padStart(2, '0');
        const minute = String(koreanTime.getUTCMinutes()).padStart(2, '0');
        return `${year}-${month}-${day} ${hour}:${minute}`;
    }

    public conversationDate(value: string) {
        const date = this.consultationDate(value);
        if (!date) return value || '';
        const koreanTime = new Date(date.getTime() + (9 * 60 * 60 * 1000));
        const year = koreanTime.getUTCFullYear();
        const month = koreanTime.getUTCMonth() + 1;
        const day = koreanTime.getUTCDate();
        const weekday = ['일', '월', '화', '수', '목', '금', '토'][koreanTime.getUTCDay()];
        return `${year}년 ${month}월 ${day}일 (${weekday})`;
    }

    public conversationTime(value: string) {
        const date = this.consultationDate(value);
        if (!date) return value || '';
        const koreanTime = new Date(date.getTime() + (9 * 60 * 60 * 1000));
        const hour = String(koreanTime.getUTCHours()).padStart(2, '0');
        const minute = String(koreanTime.getUTCMinutes()).padStart(2, '0');
        return `${hour}:${minute}`;
    }
    public showAnswerDateDivider(answerIndex: number) {
        const answers = this.selectedItem?.adminAnswers || [];
        const currentDate = this.dateKey(answers[answerIndex]?.answeredAt);
        const previousDate = answerIndex > 0
            ? this.dateKey(answers[answerIndex - 1]?.answeredAt)
            : this.dateKey(this.selectedItem?.createdAt || '');
        return !!currentDate && currentDate !== previousDate;
    }

    private consultationTimestamp(value: string) {
        const date = this.consultationDate(value);
        return date ? date.getTime() : 0;
    }

    private consultationDate(value: string): Date | null {
        const text = (value || '').trim();
        if (!text) return null;
        const hasTimezone = /(Z|[+-]\\d{2}:?\\d{2})$/i.test(text);
        const normalized = hasTimezone
            ? text
            : `${text.replace(' ', 'T')}Z`;
        const timestamp = Date.parse(normalized);
        return Number.isFinite(timestamp) ? new Date(timestamp) : null;
    }
    private buildDocumentBundle(message: string): DocumentBundle | null {
        const lines = (message || '').split(/\r?\n/);
        const headerIndex = lines.findIndex((line) => !!line.trim());
        if (headerIndex < 0) return null;

        const header = /^\[서류\s*발송\]\s*(.*)$/.exec(lines[headerIndex].trim());
        if (!header) return null;

        const contentLines = lines.slice(headerIndex + 1);
        const attachments: DocumentAttachment[] = [];
        const messageLines: string[] = [];
        for (const contentLine of contentLines) {
            const line = contentLine.trim();
            const urlMatch = /(https?:\/\/\S+)$/i.exec(line);
            if (!urlMatch) {
                messageLines.push(contentLine.trimEnd());
                continue;
            }

            const url = urlMatch[1];
            const description = line.slice(0, urlMatch.index).replace(/[\s:]+$/, '').trim();
            const parts = description.split(/\s+-\s+/, 2);
            const label = parts[0] || '첨부 문서';
            const isQuote = this.isQuoteDocumentUrl(url);
            attachments.push({
                kind: isQuote ? 'quote' : 'attachment',
                label: isQuote ? '견적서 PDF' : label,
                fileName: isQuote ? 'PDF 문서' : (parts[1] || ''),
                url
            });
        }

        while (messageLines.length && !messageLines[0].trim()) messageLines.shift();
        while (messageLines.length && !messageLines[messageLines.length - 1].trim()) messageLines.pop();
        const normalizedMessageLines = messageLines.filter((line, index) => (
            !!line.trim() || index === 0 || !!messageLines[index - 1].trim()
        ));

        return {
            title: header[1].trim() || '거래 관련 서류',
            message: normalizedMessageLines.join('\n'),
            attachments
        };
    }

    private isQuoteDocumentUrl(url: string) {
        return /\/ip-market\/documents\/[^/?#]+\/quote(?:[?#]|$)/i.test(url);
    }

    private buildAiCandidate(item: ConsultationItem): AiCandidateDetail | null {
        if (item.flow !== 'ai_candidate_consultation') return null;

        const values: { [key: string]: string } = {};
        for (const line of item.requestLines || []) {
            const separator = line.indexOf(':');
            if (separator < 0) continue;
            const label = line.slice(0, separator).trim();
            const value = line.slice(separator + 1).trim();
            if (label && value) values[label] = value;
        }

        const factLabels = ['등록번호', '권리 유형', '권리자', '등록 상태'];
        const searchLabels = ['검색 권리', '검색 키워드', '기술 내용', '상표명', '지정 상품', '상표류', '디자인류', '출원일 기준', '검색 조건'];
        return {
            title: values['상담 후보'] || item.subject,
            candidateId: values['후보 번호'] || '',
            matchRate: values['일치도'] || '',
            facts: factLabels
                .filter((label) => !!values[label])
                .map((label) => ({ label, value: values[label] })),
            analysis: values['AI 분석'] || '',
            summary: values['후보 요약'] || '',
            searchConditions: searchLabels
                .filter((label) => !!values[label])
                .map((label) => ({ label, value: values[label] })),
            request: values['상담 요청'] || ''
        };
    }

    private syncSelectedItem() {
        const visible = this.filteredItems;
        const selectedId = this.selectedItem?.id;
        const refreshedItem = selectedId
            ? visible.find((item) => item.id === selectedId)
            : null;
        this.selectedItem = refreshedItem || visible[0] || null;
    }

    private matchesFilter(item: ConsultationItem, filter: ConsultationFilter) {
        if (filter === 'sale') return item.flow === 'sale_registration';
        if (filter === 'buy') return item.flow === 'buy_inquiry';
        if (filter === 'qna') return ['general_qna', 'right_specific_qna', 'requirement_qna'].includes(item.flow);
        if (filter === 'case') return item.flow === 'case_consultation';
        if (filter === 'valuation') return item.flow === 'valuation_request';
        if (filter === 'ai') return item.flow === 'ai_candidate_consultation';
        return true;
    }

    private dateKey(value: string) {
        return (value || '').slice(0, 10);
    }
}

export default PageConsultationsComponent;